export const environment = {
    'backendBaseUrl': 'https://tardis-apim.preprod.app.inh.re/mass-eligibility',
    'fibreBuildingApiBaseUrl': 'https://tardis-apim.staging.app.inh.re/fibre-building-api',
    'keycloakBaseUrl': 'https://sso.inherent.fr/',
    'keycloakRealm': 'pf-business-test',
    'keycloakClientId': '438d5dc5-d30f-42d3-8607-23216d251fc5',
    'stompWebsocketUrl': 'wss://mass-eligibility-rmq.preprod.app.inh.re/ws',
    'stompWebsocketUsername': 'mass-eligibility-front',
    'stompWebsocketPassword': 'X35Q8Y0FgU8km1pwk4TmqEYo1aK19i',
    'stompWebsocketHost': 'mass-eligibility'
};
